import angular from 'angular';
import uiRouter from 'angular-ui-router';


import MessageOutbound from './messageOutbound.component';

import NewMessage from './new/new';
import MessageHistory from './history/history';
import MessageActivePromo from './active_promo/active_promo';
import Settings from './settings/settings';

const messageOutboundModule = angular.module('tinaba.components.messageOutbound', [
  uiRouter,
  NewMessage.name,
  MessageHistory.name,
  MessageActivePromo.name,
  Settings.name
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('messageOutbound', {
    url: '/message',
    template: '<message-outbound></message-outbound>',
    redirect: 'messageOutbound.new',
    data: {
      services: true // show services in sidenav
    }
  });
})

.component('messageOutbound', MessageOutbound);

export default messageOutboundModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/messageOutbound.js
 **/